"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;

var _react = _interopRequireDefault(require("react"));

var _SvgIconWrap = _interopRequireDefault(require("../../../components/SvgIcon/SvgIconWrap"));

function Image(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIconWrap.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.99785183,9.83325674 C4.83359446,9.83325674 5.53737773,9.54734479 6.13119486,8.95352766 C6.72501199,8.35971053 7.01092394,7.65592726 7.01092394,6.82018463 C7.01092394,5.98444201 6.72501199,5.28065874 6.13119486,4.68684161 C5.53737773,4.09302448 4.83359446,3.80711253 3.99785183,3.80711253 C3.1621092,3.80711253 2.45832594,4.09302448 1.86450881,4.68684161 C1.27069168,5.28065874 0.984779727,5.98444201 0.984779727,6.82018463 C0.984779727,7.65592726 1.27069168,8.35971053 1.86450881,8.95352766 C2.45832594,9.54734479 3.1621092,9.83325674 3.99785183,9.83325674 Z M8.50646338,14.3418683 L5.99923549,11.8346404 L1.00677295,16.8271029 L1.00677295,19.8181818 L23,19.8181818 L23,12.8243356 L16.511998,6.33633364 L8.50646338,14.3418683 Z"
  }));
}